import { FunctionComponent } from 'react';
import { useAppData } from '@/contexts/AppData';
import { Membership } from '@/components/Membership';
import { LoginContentLayout } from '@/layouts/loginContent';
import {
  hasMembershipSelector,
  isLoggedInSelector,
  membershipErrorSelector,
} from '@/store/selectors/membership';
import { useAppSelector } from '@/hooks/useAppSelector';

export const LoginView: FunctionComponent = () => {
  const { membershipConfig, listingId } = useAppData();

  const hasMembership = useAppSelector(hasMembershipSelector);
  const isLoggedIn = useAppSelector(isLoggedInSelector);
  const membershipError = useAppSelector(membershipErrorSelector);

  return (
    <>
      <div className="member-login">
        <div className="member-login__content">
          <LoginContentLayout
            hasMembership={hasMembership}
            isLoggedIn={isLoggedIn}
            membershipError={membershipError}
          />
        </div>
        <Membership {...membershipConfig} listingId={listingId} />
      </div>
    </>
  );
};
